export const colors = {
  green: {
    dark: "#00341C",
    light: "#C1F9CC"
  },
  black: {
    100: "#1A1A1A",
    off: "#222222"
  },
  white: { 100: "#F9F6F2" },
  grey: { 100: "#B3B3B3" },
  purple: {
    100: "#D2ADFF",
    200: "#BA81FF",
    300: "#A55AFF",
    400: "#963EFF",
    500: "#8F31FF",
    600: "#8525F6",
    700: "#7E25E9",
    800: "#761FDE",
    900: "#6B19CD",
    1000: "#A269FF"
  }
};
